import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import locationApi, { LocationUpdateRequest } from '../apis/location.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'

interface LocationEditRouteState {
  id: number
}

interface LocationEditProps
  extends RouteComponentProps<any, any, LocationEditRouteState> {}

interface LocationEditState {
  name: string
  capacity: string
}

class LocationEdit extends Component<LocationEditProps, LocationEditState> {
  constructor (props: LocationEditProps) {
    super(props)
    this.state = {
      name: '',
      capacity: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    if (name === 'capacity') this.setState({ capacity: value })
  }

  handleSaveClick () {
    const { name, capacity } = this.state
    const payload: LocationUpdateRequest = {}
    if (name) payload.location = name
    if (capacity) payload.capacity = Number(capacity)
    locationApi.update(this.id, payload, location => {
      if (!location) return
      this.props.history.push(routes.locations)
    })
  }

  readLocation () {
    locationApi.read(this.id, location => {
      if (!location) return
      const { name, capacity } = location
      this.setState({ name, capacity: String(capacity) })
    })
  }

  componentDidMount () {
    this.readLocation()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="oneThird">
          <Card>
            <PageHeading
              text={i18n("Edit Location")}
              doc='locations-edit-location' />
            <Row column={1}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Location")}
                onChange={this.handleInputChange} />
              <InputText
                name="capacity"
                value={this.state.capacity}
                label={i18n("Capacity")}
                onChange={this.handleInputChange} />
            </Row>
            <CardButton
              proceedText={i18n("Save")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(LocationEdit)
